import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BrandLockup, PoweredByAdmissionHall } from "@/components/Brand";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/admin/login", { email, password });
      login(data.user);
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-6">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm border border-slate-200 bg-white p-8"
      >
        <div className="flex items-center gap-2">
          <BrandLockup size="md" wordmark="always" />
          <span className="border border-slate-300 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-widest text-slate-500">
            <ShieldCheck className="mr-1 inline h-3 w-3 text-[#1A365D]" /> Admin
          </span>
        </div>
        <p className="mt-2 text-sm text-slate-500">Ingestion, validation and publishing console.</p>
        <PoweredByAdmissionHall className="mt-2 block" />

        <label className="mt-7 block">
          <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Email</span>
          <input
            data-testid="admin-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 h-11 w-full border border-slate-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#1A365D]"
          />
        </label>
        <label className="mt-4 block">
          <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Password</span>
          <input
            data-testid="admin-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 h-11 w-full border border-slate-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#1A365D]"
          />
        </label>
        <button
          data-testid="admin-login-submit"
          disabled={busy}
          className="mt-6 h-11 w-full bg-[#1A365D] text-sm font-semibold text-white hover:bg-[#122845] disabled:opacity-40"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <Link
          to="/login"
          data-testid="user-login-link"
          className="mt-6 block text-center text-xs font-semibold uppercase tracking-widest text-slate-400 hover:text-[#1A365D]"
        >
          User login
        </Link>
      </form>
    </div>
  );
}
